import { render } from "./ParuTion.vue?vue&type=template&id=ed948cde&scoped=true&ts=true"
import script from "./ParuTion.vue?vue&type=script&lang=ts"
export * from "./ParuTion.vue?vue&type=script&lang=ts"

import "./ParuTion.vue?vue&type=style&index=0&id=ed948cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed948cde"]])

export default __exports__